import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import {
	FooterContainer,
	Column,
	ColumnTitle,
	StyledLink,
	FooterFooter,
	Copyright,
	BackToTop,
} from './footerStyles';
import Logo from 'core/icons/Logo';
import { svgMap } from 'core/utils/slugMaps';
import { getColor } from 'core/utils/Styles';
import SignupWidget from 'core/components/SignupWidget/SignupWidget';


class Footer extends PureComponent {
	state = {
		bottomEnabled: true,
	}

	toggleBottomEnabled = bottomEnabled => {
		this.setState({ bottomEnabled });
	}

	smoothScroll = (e) => {
		e.preventDefault();
		window.scroll({ top: 0, left: 0, behavior: 'smooth' });
	}


	render () {
		const { renderEmail, footerItems, signupWidget  } = this.props;
		const dt = new Date(Date.now());
		const year = dt.getFullYear();

		return (
			<Fragment>
				<BackToTop onClick={this.smoothScroll} href={"#"}>Back To Top</BackToTop>
				{ renderEmail && <SignupWidget {...signupWidget} /> }
				<FooterContainer>
					{footerItems.map((column, colIdx) => (
						<FooterColumn {...column} key={colIdx} />
					))}
				</FooterContainer>
				<FooterFooter>
					<Logo />
					<Copyright>
						&copy; {year} Cratejoy. All Rights Reserved.
					</Copyright>
				</FooterFooter>
			</Fragment>

		);
	}

	static propTypes = {
		renderEmail: PropTypes.bool,
		signupWidget: PropTypes.object,
		footerItems: PropTypes.array,
	}
}

class FooterColumn extends PureComponent {
	render () {
		const { title, items, openNewWindow } = this.props;

		return (
			<Column>
				<ColumnTitle>{title}</ColumnTitle>
				{items.map((link, linkIdx) => (
					<FooterLink {...link} key={`link-${linkIdx}`} target={openNewWindow ? "_blank" : null} />
				))}
			</Column>
		);
	}

	static propTypes = {
		title: PropTypes.string,
		items: PropTypes.array,
		openNewWindow: PropTypes.bool,
	}
}

class FooterLink extends PureComponent {
	render () {
		const { amp, url, copy, icon, openNewWindow } = this.props;
		const Icon = icon ? svgMap[icon] : null;

		return (
			<StyledLink href={url} target={openNewWindow ? "_blank" : null}>
				{ Icon && <Icon width={16} height={16} fill={getColor('gray')} /> }
				{copy}
			</StyledLink>
		);
	}

	static propTypes = {
		amp: PropTypes.bool,
		url: PropTypes.string,
		copy: PropTypes.string,
		icon: PropTypes.string,
		openNewWindow: PropTypes.bool,
	}
}

export default hot(module)(Footer);
